import { CHAR_ERR, DATA_ERR, DATA_MISS, NUMERIC_ERR } from "./GlobalMessageConstants";

export const VEHICLE_HEAD_CELLS = [
  {
    id: "unitNo",
    numeric: false,
    disablePadding: false,
    label: "Unit#",
  },
  {
    id: "year",
    numeric: true,
    disablePadding: false,
    label: "Year",
  },
  {
    id: "makeModel",
    numeric: false,
    disablePadding: true,
    label: "Make/Model",
  },
  {
    id: "engine",
    numeric: false,
    disablePadding: false,
    label: "Engine",
  },

  {
    id: "sortBy",
    numeric: false,
    disablePadding: false,
    label: "Sort By",
  },
];
export const VEHICLES_TO_COPY = [
  {
    id: "unitNo",
    numeric: false,
    disablePadding: false,
    label: "Unit#",
  },
  {
    id: "year",
    numeric: true,
    disablePadding: false,
    label: "Year",
  },
  {
    id: "makeModel",
    numeric: false,
    disablePadding: true,
    label: "Make/Model",
  },
  {
    id: "engine",
    numeric: false,
    disablePadding: false,
    label: "Engine",
  },
];
export const INTERCHANGE_HEADER_DATA = [
  {
    id: "partNumber",
    numeric: false,
    disablePadding: true,
    label: "Part Number",
  },
  {
    id: "brand",
    numeric: false,
    disablePadding: false,
    label: "Brand",
  },
  {
    id: "partType",
    numeric: true,
    disablePadding: false,
    label: "Part Type",
  },
  {
    id: "compPartNum",
    numeric: false,
    disablePadding: false,
    label: "Comp Part",
  },
  {
    id: "compBrand",
    numeric: false,
    disablePadding: false,
    label: "Comp Brand",
  },
];

export const PARTS_HEAD_CELLS = [
  {
    id: "partType",
    numeric: false,
    disablePadding: true,
    label: "Filter Type",
  },

  {
    id: "partNumber",
    numeric: false,
    disablePadding: true,
    label: "Part Number",
  },

  {
    id: "quantity",
    numeric: false,
    disablePadding: true,
    label: "Qty",
  },

  {
    id: "brand",
    numeric: false,
    disablePadding: true,
    label: "Brand",
  },
];
export const VEHICLE_CREATION_FORM_VALUES = [
  {
    label: "Make",
    key: "make",
    testid: "make-onchange-test",
    fieldType: "textField",
    type: "text",
    required: true,
    InputLabelProps: true,
  },
  {
    label: "Model",
    key: "model",
    testid: "model-onchange-test",
    fieldType: "textField",
    type: "text",
    required: true,
    InputLabelProps: true,
  },
  {
    label: "Make/Model",
    key: "makeModel",
    testid: "makeModel-onchange-test",
    fieldType: "textField",
    type: "text",
    required: false,
    InputLabelProps: false,
  },
  {
    label: "SubModel",
    key: "subModel",
    testid: "subModel-onchange-test",
    fieldType: "textField",
    type: "text",
    required: false,
    InputLabelProps: true,
  },
  {
    label: "Engine",
    key: "engine",
    testid: "engine-onchange-test",
    fieldType: "textField",
    type: "text",
    required: false,
    InputLabelProps: true,
  },
  {
    label: "VIN",
    key: "vin",
    testid: "vin-onchange-test",
    fieldType: "textField",
    type: "text",
    required: false,
    InputLabelProps: true,
  },
  {
    label: "Year",
    key: "year",
    testid: "year-onchange-test",
    fieldType: "textField",
    type: "text",
    required: false,
    InputLabelProps: true,
  },
  {
    label: "Unit",
    key: "unitNo",
    testid: "unitNo-onchange-test",
    fieldType: "textField",
    type: "text",
    required: false,
    InputLabelProps: true,
  },
  {
    label: "Sort",
    key: "sortBy",
    testid: "sortBy-onchange-test",
    fieldType: "textField",
    type: "text",
    required: false,
    InputLabelProps: true,
  },
  {
    label: "Comments",
    key: "comments",
    testid: "comments-onchange-test",
    fieldType: "textField",
    type: "text",
    required: false,
    InputLabelProps: true,
  },
];

//--store form keys ---//
export const STORE_CREATION_FORM_VALUES = [
  {
    label: "Existing Stores",
    key: "existingStores",
    testid: "Select-store",
    fieldType: "select",
    type: "select",
    width: "fullWidth",
  },
  {
    label: "Store Name",
    key: "storeName",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
    required: "true",
    testId: "storeName",
  },
  {
    label: "Multi Grid",
    elements: [
      {
        label: "NAPA Store Code",
        key: "napaStoreCode",
        testid: "",
        fieldType: "TextField",
        type: "text",
        width: "half",
        error:{validationErr:CHAR_ERR, dataErr:DATA_MISS},
        required:"true",
        inputProps:{
          inputMode:"numeric",
          pattern:"[0-9]*",
          maxLength:3
        },
         testId: "napaStoreCode",

      },
      {
        label: "DC Code",
        key: "dcCode",
        testid: "Select-dccode",
        fieldType: "select",
        type: "text",
        width: "half",
        search: true,
        error:{validationErr:NUMERIC_ERR, dataErr:DATA_ERR},
      
        required:true,
        inputProps:{
          inputMode:"text",
          pattern:"[^0-9]*"
        }
      },
    ],
  },

  {
    label: "Address",
    key: "address",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
  {
    label: "City",
    key: "city",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
  {
    label: "Select Country",
    key: "selectCountry",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },

  {
    label: "Select State",
    key: "selectStates",
    testid: "Select-state-store",
    fieldType: "select",
    type: "select",
    width: "fullWidth",
  },

  {
    label: "Zip Code",
    key: "zipCode",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
  {
    label: "Phone",
    key: "phone",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
  {
    label: "Fax",
    key: "fax",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
  {
    label: "Email",
    key: "email",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
];



// export const getNapaStoreCode = () => {
//   const arr = Array.from({ length: 999 }, (_, i) => {
//     const num = String(i + 1).padStart(3, "0");
//     return {
//       id:num,
//       label: num,
//     };
//   });
//   return arr;
// };


//--fleet form keys ---//
export const FLEET_CREATION_FORM_VALUES = [
  {
    label: "Select Existing Fleets",
    key: "existingFleets",
    testid: "Select-fleet",
    fieldType: "select",
    type: "select",
    width: "fullWidth",
  },
  {
    label: "Fleet Name",
    key: "fleetName",
    testid: "",
    error:{validationErr:CHAR_ERR},
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
    required: true,
  },
  {
    label: "AR Account No",
    key: "arNo",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
    error:{validationErr:CHAR_ERR},
    inputProps:{
      maxLength:5,
      inputMode:"numeric"
    },
        required: true,

  },
  {
    label: "Address",
    key: "address",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
  {
    label: "City",
    key: "city",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
  {
    label: "Select Country",
    key: "selectCountry",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },

  {
    label: "Select State",
    key: "selectStates",
    testid: "Select-state-fleet",
    fieldType: "select",
    type: "select",
    width: "fullWidth",
  },

  {
    label: "Zip Code",
    key: "zipCode",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
  {
    label: "Phone",
    key: "phone",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
  {
    label: "Fax",
    key: "fax",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
  {
    label: "Email",
    key: "email",
    testid: "",
    fieldType: "TextField",
    type: "text",
    width: "fullWidth",
  },
];

export const VEHICLE_TABLE_SURVEY = [
  {
    valueFor: "unitNo",
    id: "unit",
    defaultValue: "",
    type: "input",
  },
  {
    valueFor: "year",
    id: "year",
    defaultValue: "",
    type: "text",
  },
  {
    valueFor: "makeModel",
    id: "makeModel",
    defaultValue: "",
    type: "text",
  },
  {
    valueFor: "engine",
    id: "engine",
    defaultValue: "",
    type: "text",
  },
  {
    valueFor: "sortBy",
    id: "sort",
    defaultValue: "",
    type: "input",
  },
  {
    valueFor: "check",
    id: "check",
    defaultValue: false,
    type: "check",
  },
  {
    valueFor: "status",
    id: "status",
    defaultValue: false,
    type: "status",
  },
];

export const PART_TABLE_SURVEY = [
  {
    valueFor: "partType",
    id: "partType",
    defaultValue: "",
    type: "text",
  },
  {
    valueFor: "partNumber",
    id: "partNumber",
    altValueFor: "competitorPartNumber",
    defaultValue: "",
    type: "text",
  },
  {
    valueFor: "quantity",
    id: "quantity",
    defaultValue: 0,
    type: "text",
  },
  {
    valueFor: "brand",
    id: "brand",
    defaultValue: "",
    type: "text",
  },
  {
    valueFor: "check",
    id: "check",
    defaultValue: false,
    type: "check",
  },
];
export const VEHICLE_TO_COPY_TABLE_SURVEY = [
  {
    valueFor: "radio",
    id: "radio",
    defaultValue: false,
    type: "radio",
  },
  {
    valueFor: "unitNo",
    id: "unit",
    defaultValue: "",
    type: "text",
  },
  {
    valueFor: "year",
    id: "year",
    defaultValue: "",
    type: "text",
  },
  {
    valueFor: "makeModel",
    id: "makeModel",
    defaultValue: "",
    type: "text",
  },
  {
    valueFor: "engine",
    id: "engine",
    defaultValue: "",
    type: "text",
  },
];
export const COMP_VIEW_TABLE_SURVEY = [
  {
    valueFor: "partNumber",
    id: "partNumber",
  },
  {
    valueFor: "brand",
    id: "brand",
  },
  {
    valueFor: "partType",
    id: "partType",
  },
  {
    valueFor: "compPartNum",
    id: "compPartNum",
  },
  {
    valueFor: "compBrand",
    id: "compBrand",
  },
];
// -- survey form keys ---//
export const SURVEY_CREATION_FORM_VALUES = {
  surveyLabel: "Select Existing Surveys",
  nameLabel: "Name",
  dateCreatedLabel: "Date Created",
  dateRevisedLabel: "Date Revised",
};
